import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import moment from 'moment';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withSetsSearch from '../../common/withSetsSearch';
import withTableName from '../../common/withTableName';
import withSelectedSetsPayload from '../../common/withSelectedSetsPayload';
import withSetsFilter from '../../common/withSetsFilter';
import withPreferenceOptions from '../../common/withPreferenceOptions';
import withUser from '../../common/withUser';
import withOnline from '../../common/withOnline';
import Header from '../../components/Header';
import Components from '../../components/ManageCase/Components';
import SetsList from '../../components/Sets/SetsList';
import { CAPITALIZE, onGoBack } from '../../common/globals';
import SetContents from '../../components/Sets/SetContents';
import {
  updateTableWiseCaseByCaseId, getTableCaseByCaseId
} from '../../utils/db';
import SetsMasterGroup from '../../components/ManageCase/SetsMasterGroup';
import { listSingleCase, updateCase } from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import ACMProductGoBackModal from '../../components/Models/ACMProductGoBackModal';
import CaseChangesNoLonger from '../../components/Models/CasesChangesNoLonger';
import SaveSetsModal from '../../components/Models/SaveSetsModal';

class Sets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isComponent: false,
      selectedComponent: '',
      isSetContents: false,
      isSetStatus: false,
      isGroup: false,
      selectedGroup: '',
      caseDetail: {},
      preferenceOptions: {},
      selectedSetsCount: 0
    };

    this._onChildSetsSave = null;
    this.setBackModal = null;
    this.caseChangesNoLonger = null;
    this.saveSetsModal = null;
  }

  componentDidMount() {
    try {
      this.setBackModal = new window.bootstrap.Modal(
        window.$('#acmProductGoBackModal')
      );
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
      this.saveSetsModal = new window.bootstrap.Modal(window.$('#saveSetsModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetLongPress = (item) => {
    try {
      const { location: { pathname } } = this.props;
      browserHistory.push(`${pathname}/${item.SetName}/set-contents`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedComponent = (selectedComponent) => {
    try {
      const { isComponent } = this.state;
      if (selectedComponent.Component !== '') {
        this.setState({
          selectedComponent, isComponent: !isComponent
        });
      } else {
        this.setState({
          selectedComponent: '', isComponent: !isComponent
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickComponent = () => {
    try {
      const { isComponent, selectedComponent } = this.state;
      if (selectedComponent.Component === undefined) {
        this.setState({
          isComponent: !isComponent
        });
      } else {
        this.setState({
          selectedComponent: ''
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedSetsGroup = (selectedGroup) => {
    try {
      const { isGroup } = this.state;
      if (selectedGroup.SetGroup !== '') {
        this.setState({
          selectedGroup,
          isGroup: !isGroup
        });
      } else {
        this.setState({
          selectedGroup: '',
          isGroup: !isGroup
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickGroup = () => {
    try {
      const { isGroup, selectedGroup } = this.state;
      if (selectedGroup === '') {
        this.setState({
          isGroup: !isGroup
        });
      } else {
        this.setState({
          selectedGroup: ''
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onComponentBack = () => {
    try {
      const { isComponent } = this.state;
      this.setState({
        isComponent: !isComponent
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGroupBack = () => {
    try {
      this.setState({ isGroup: false });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetContentBack = () => {
    try {
      browserHistory.goBack();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSave = async () => {
    try {
      const {
        params: { id }, online, setLoader, notify, tableName, goBack, user: { name }
      } = this.props;
      const { preferenceOptions } = this.state;
      this._onChildSetsSave(async (sets) => {
        const caseDetail = await getTableCaseByCaseId(id, tableName);
        if (caseDetail && caseDetail.DGR === '1') {
          this.caseChangesNoLonger.show();
          return;
        }
        // console.log(sets);
        let newSets = [];
        sets.map((item) => {
          const findIndex = _.findIndex(caseDetail.case_sets,
            { SetName: item.SetName, PreferenceName: item.PreferenceName });
          if (findIndex !== -1) {
            newSets.push({
              ...item,
              CasePlanID: caseDetail.case_sets[findIndex].CasePlanId,
              PreferenceName: caseDetail.case_sets[findIndex].PreferenceName
            });
          } else {
            newSets.push({ ...item, CasePlanID: '' });
          }
        });
        newSets = _.orderBy(newSets, ['CasePlanID'], ['desc']);
        const newUsers = newSets.map(({
          CasePlanID, SetName, PreferenceName, Quantity
        }) => ({
          CasePlanID,
          SetName,
          PreferenceName,
          Quantity: Number(Quantity)
        }));
        caseDetail.selectedSets = newUsers;
        if (Object.keys(preferenceOptions).length > 0) {
          if (preferenceOptions.type === 'append') {
            const comments = caseDetail.Comments && caseDetail.Comments !== null ? caseDetail.Comments : '';
            caseDetail.Comments = preferenceOptions.preferenceComments
              ? `${comments !== '' ? `${comments}\n` : ''}${preferenceOptions.preferenceComments}`
              : caseDetail.Comments;
            const repNotesValue = caseDetail.RepNotes && caseDetail.RepNotes !== null ? caseDetail.RepNotes : '';
            caseDetail.RepNotes = preferenceOptions.preferenceRepNotes
              ? `${repNotesValue !== '' ? `${repNotesValue}\n` : ''}${preferenceOptions.preferenceRepNotes}`
              : caseDetail.RepNotes;
          } else {
            caseDetail.Comments = preferenceOptions.preferenceComments;
            caseDetail.RepNotes = preferenceOptions.preferenceRepNotes;
          }
        }
        if (online) {
          setLoader(true);
          const {
            CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
            PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
            ProductSubmitted, RepPONumber, Submitted, CoverRep, DGRUpload,
            MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
            case_sets
          } = caseDetail;
          const subset = {
            CaseScheduleID,
            CaseDate,
            CaseTime,
            CustomerNo,
            CustomerName,
            SurgeonName,
            PatientID: (PatientID !== null) ? (PatientID.toUpperCase()) : null,
            ProcedureType,
            CaseType,
            Side,
            Comments: (Comments !== null) ? CAPITALIZE(Comments) : null,
            RepNotes: (RepNotes !== null) ? CAPITALIZE(RepNotes) : null,
            ProductNotes,
            ProductSubmitted,
            RepPONumber,
            Submitted,
            CoverRep: (CoverRep !== null) ? CoverRep : name,
            ChangeRep: name,
            DGRUpload,
            MRN,
            Gender,
            Age,
            ACMPlannedParts,
            ACMSelectedParts,
            Height,
            Weight,
            selectedSets,
            case_sets
          };
          const compareValue = await this.compareUpdatedValue();
          if (compareValue) {
            subset.Submitted = '0';
            subset.Synced = (subset.Synced === '1' ? '0' : subset.Synced);
          }
          await updateCase(subset);
          setLoader(false);
          const caseRes = await listSingleCase(caseDetail.CaseScheduleID);
          const { message, status } = caseRes;
          if (status) {
            const caseDetails = caseRes.data[0];
            caseDetails.id = parseInt(id, 10);
            caseDetails.CaseDate = caseDetail.CaseDate;
            caseDetails.CaseTime = caseDetail.CaseTime;

            // Update the response when update API change
            updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
            if (message.length > 0) {
              // notify({ type: 'success', message });
            }
            // this._onSetBack();
            onGoBack(goBack);
          } else {
            notify({ type: 'error', message });
          }
        } else {
          notify({
            type: 'warn',
            message: 'You must have as internet connection. Please check your connection and try again.'
          });
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  compareUpdatedValue = async () => {
    const { caseDetail } = this.state;
    let oldSets = [];
    oldSets = caseDetail.case_sets.map(
      ({ Quantity, DeviceType, SetName }) => ({ Quantity: Number(Quantity), DeviceType, SetName })
    );
    let newSets = [];
    this._onChildSetsSave(async (selectedSets) => {
      const filteredSets = selectedSets.filter((item) => item.Quantity > 0);
      newSets = filteredSets.map(
        ({ Quantity, DeviceType, SetName }) => (
          { Quantity: Number(Quantity), DeviceType, SetName })
      );
    });
    if (JSON.stringify(newSets) === JSON.stringify(oldSets)) {
      return false;
    }
    return true;
  }

  _onSetBack = () => {
    try {
      const { goBack, setSetsSearch, setSetsFilter } = this.props;
      const { caseDetail } = this.state;
      let oldSets = [];
      oldSets = caseDetail.case_sets.map(
        ({ Quantity, DeviceType, SetName }) => ({ Quantity: Number(Quantity), DeviceType, SetName })
      );
      this._onChildSetsSave(async (selectedSets) => {
        selectedSets = selectedSets.map(
          ({ Quantity, DeviceType, SetName }) => (
            { Quantity: Number(Quantity), DeviceType, SetName })
        );
        if (JSON.stringify(selectedSets) !== JSON.stringify(oldSets)) {
          this.setBackModal.show();
        } else {
          onGoBack(goBack);
          setSetsFilter({});
          setSetsSearch({});
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBackCancel = () => {
    try {
      const { goBack, setSetsSearch } = this.props;
      setSetsSearch({});
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSaveSet = () => {
    try {
      const {
        online, notify, setSetsFilter, setSetsSearch
      } = this.props;
      setSetsFilter({});
      setSetsSearch({});
      this._onChildSetsSave(async (selectedSets) => {
        if (!online) {
          notify({
            type: 'warning',
            message: 'You must have as internet connection. Please check your connection and try again.'
          });
        }
        let selectedSetsCount = 0;
        selectedSets = selectedSets.map(({ Quantity, DeviceType, SetName }) => {
          if (typeof Quantity !== 'undefined' && Number(Quantity) > 0) {
            selectedSetsCount += Number(Quantity);
          }
          return {
            Quantity,
            DeviceType,
            SetName
          };
        });

        console.log(selectedSetsCount);

        // this.setState({ selectedSetsCount, selectedSets }, () => {
        //   this.saveSetsModal.show();
        // });

        this.setState({ selectedSets }, () => {
          this.saveSetsModal.show();
        });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeSetView = () => {
    try {
      const { isSetContents, isSetStatus } = this.state;
      const { location: { pathname } } = this.props;
      const routeComponents = pathname.split('/');
      if (isSetContents) {
        routeComponents.splice(routeComponents.length - 1, 1, 'set-status');
      }
      if (isSetStatus) {
        routeComponents.splice(routeComponents.length - 1, 1, 'set-contents');
      }
      browserHistory.replace(routeComponents.join('/'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetSetsCount = async (quantity) => {
    try {
      this.setState({ selectedSetsCount: quantity });
    } catch (e) {
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { location: { pathname } } = nextProps;
    if (pathname.includes('set-contents')) {
      nextState.isSetContents = true;
      nextState.isSetStatus = false;
      return;
    }
    if (pathname.includes('set-status')) {
      nextState.isSetStatus = true;
      nextState.isSetContents = false;
      return;
    }
    nextState.isSetStatus = false;
    nextState.isSetContents = false;
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        params: { id }, tableName, preferenceOptions,
        setsFilter: { selectedComponent = '', selectedGroup = '' }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      this.setState({
        caseDetail, preferenceOptions, selectedComponent, selectedGroup
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { params: { id, setName } } = this.props;
    const {
      isSetContents, isSetStatus, isComponent, selectedComponent, isGroup,
      selectedGroup, caseDetail, selectedSetsCount
    } = this.state;
    return (
      <section className={`list-section ${isSetContents || isSetStatus ? 'resizer-class' : ''}`}>
        <Header
          actionButton={
            (isComponent || isGroup)
              ? ''
              : (isSetContents || isSetStatus)
                ? { title: isSetContents ? 'Status' : 'Contents', onClick: this._onChangeSetView }
                : { title: 'Save', onClick: this._onSaveSet }
          }
          title={
            isComponent
              ? 'Components'
              : isGroup
                ? 'Groups'
                : isSetContents
                  ? 'Set Contents'
                  : isSetStatus
                    ? 'Set Status'
                    : 'Sets'
          }
          goBack={
            isComponent
              ? this._onComponentBack
              : isGroup
                ? this._onGroupBack
                : isSetContents || isSetStatus
                  ? this._onSetContentBack
                  : this._onSetBack
          }
        />
        {(isSetContents || isSetStatus
          ? (
            <SetContents
              setName={setName}
              isSetStatus={isSetStatus}
              setType="officeset"
              isSetContents={isSetContents}
            />
          )
          : isComponent ? (
            <Components
              onSelectedComponent={this._onSelectedComponent}
              caseType={caseDetail.CaseType}
            />
          )
            : isGroup ? (
              <SetsMasterGroup
                onSelectedSetsGroup={this._onSelectedSetsGroup}
                caseType={caseDetail.CaseType}
              />
            )
              : caseDetail.case_sets && (
                <SetsList
                  setChildSetsSave={(fun) => { this._onChildSetsSave = fun; }}
                  id={id}
                  isPastRec={moment(caseDetail.CaseDate, 'YYYY-MM-DD').isSameOrBefore()}
                  showHeaderButton
                  isSetContents={isSetContents}
                  onSetLongPress={this._onSetLongPress}
                  selectedComponent={selectedComponent}
                  onClickComponent={this._onClickComponent}
                  selectedGroup={selectedGroup}
                  onClickGroup={this._onClickGroup}
                  caseTypePreferenceValue={caseDetail.CaseType}
                  caseDetail={caseDetail}
                  onGetSetsCount={this._onGetSetsCount}
                />
              )
        )}
        <ACMProductGoBackModal
          onSave={this._onSaveSet}
          onCancel={this._onBackCancel}
        />
        <CaseChangesNoLonger
          id={caseDetail.id}
        />
        <SaveSetsModal
          selectedSetsCount={selectedSetsCount}
          onSave={this._onSave}
          setsSave
        />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'SetsForm',
});

export default withSelectedSetsPayload(
  withUser(
    withPreferenceOptions(
      withTableName(
        withSetsSearch(
          withSetsFilter(
            withOnline(
              withGoBack(
                withForm(
                  withNotify(
                    withLoader(
                      Sets
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
